import React, { useEffect, useState } from 'react';
import styles from './Viewer.scss';

import { Loader } from 'wix-style-react';

export interface ViewerProps {
  revisionLink: string;
  onLoad(): void;
}

export const Viewer: React.FC<ViewerProps> = ({ revisionLink, onLoad }) => {
  const [isLoading, setLoading] = useState(true);
  const handleLoadEnd = () => {
    setLoading(false);
    onLoad();
  };

  useEffect(() => {
    setLoading(true);
  }, [revisionLink]);

  return (
    <div className={styles.viewer}>
      {isLoading && (
        <div className={styles.loaderContainer}>
          <Loader size="large" />
        </div>
      )}
      <iframe
        key={revisionLink}
        className={styles.iframe}
        src={revisionLink}
        onLoad={handleLoadEnd}
        data-hook="preview-iframe"
      />
    </div>
  );
};
